/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tournament_Reported_CountInputs */



/**
* | output |
* | --- |
* | "{count} reported" |
*
* @param {Tournament_Reported_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_reported_count = /** @type {((inputs: Tournament_Reported_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Reported_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} déclarés`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} declarados`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} informados`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} dichiarati`)
	return /** @type {LocalizedString} */ (`${i?.count} reported`)
});